import { Link } from 'react-router-dom';

// THIS IS A THANKYOU PAGE FOR BOOKING CONFIRMED
const BookingConfirmed = () => {
    return (
        <div className="header-spacer">
            <div className="container">
                <div className="row pb-5 mb-5">
                    <div className="col-12 text-center">
                        <h2 className="text-pr">Thank you for choosing CYAN</h2>
                        <p className="py-4">Your booking enquiry was sent and one of our expert team coordinators will contact you within 1 hour via email</p>

                        <Link to="/allOffers" className="light-btn px-3 mx-auto text-white d-flex justify-content-center align-items-center w-max mt-4">Discover more offers</Link>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default BookingConfirmed;
